import React, { ReactElement, useCallback, useRef, useState } from 'react'
import { Flexbox } from '../flexbox/flexbox'
import Collapsible from 'react-collapsible'
import { BiChevronDown, BiChevronUp } from 'react-icons/bi'
import { AppNavigationGroupContext } from './app-navigation-group-context'
import { useLocation } from 'react-router'

interface Props {
  readonly title: string
  readonly children?: ReactElement[] | ReactElement
  readonly icon?: ReactElement
  readonly pathRoot: string
}

const AppNavigationGroup = (props: Props): ReactElement => {
  const { title, children, icon, pathRoot } = props
  const [isCollapsed, setIsCollapsed] = useState(true)

  const setClosed = useCallback(() => setIsCollapsed(true), [])
  const setOpened = useCallback(() => setIsCollapsed(false), [])

  const path = useLocation().pathname
  const isInitiallyOpen = path.startsWith(`/${pathRoot}`)

  return (
    <AppNavigationGroupContext.Provider value={true}>
      <div title={title} className="mb-2">
        <Collapsible
          key={pathRoot}
          onOpen={setOpened}
          onClose={setClosed}
          transitionTime={150}
          open={isInitiallyOpen}
          trigger={
            <Flexbox className="w-full" alignItems="center">
              {icon && <div className="p-2">{icon}</div>}
              <Flexbox flex={1} className="font-medium">
                {title}
              </Flexbox>
              <Flexbox justifySelf="flex-end">
                {isCollapsed ? <BiChevronDown /> : <BiChevronUp />}
              </Flexbox>
            </Flexbox>
          }>
          {children}
        </Collapsible>
      </div>
    </AppNavigationGroupContext.Provider>
  )
}

export default React.memo(AppNavigationGroup)